import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import useLayout from './Layout/hooks/useLayout';
import Button from '../_TBComponents/Button';
import HeaderText from '../_TBComponents/HeaderText';
import Modal from '../_TBComponents/Modal';
import Text from '../_TBComponents/Text';
import Title from '../_TBComponents/Title';

const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 100%;
`;

const AccountContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const AccountItemContainer = styled('div')`
  display: flex;
  align-items: center; 
  padding: 16px 12px;
  border-bottom: 1px solid #EEEEEE;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 580px) {
    padding: 8px 6px;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const AccountItem = styled('div')`
  display: flex;
  height: auto;
  width: 100%;
  border-radius: 4px;
  align-items: center;
  gap: 16px;
`;

const AccountImageContainer = styled('div')`
  display: flex;
  width: 55px;
  height: 55px;
  background-color: ${(props) => props.background};
  border-radius: 100%;
  align-items: center;
  justify-content: center;

  img {
    height: 32px;
    width: 32px;
    object-fit: contain;
  }
`;

const NoResultsContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 352px;
`;

const ModalAccountSwitch = ({ organizationId, isOpen, onRequestClose }) => {
  const {
    isAccountLoading,
    currentUserAccounts,
    handleAccountSwitch,
  } = useLayout();

  const switchAccount = (accountCode) => {
    handleAccountSwitch(accountCode);
  };

  const getButtonName = (accountId) => {
    if (accountId === organizationId) return 'Current';
    if (isAccountLoading) return 'Switching...';
    return 'Switch';
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      hideTitle
      customBorderRadius='12px'
    >
      <ModalWrapper>
        <HeaderText fontSize='34px' fontWeight='700'>
          Switch Organization
        </HeaderText>
        {currentUserAccounts.length !== 0 ? (
          <AccountContainer>
            {currentUserAccounts.map((account) => (
              <AccountItemContainer key={account.id}>
                <AccountItem>
                  <AccountImageContainer background={account.primaryColor}>
                    <img src={account.logo} alt={account.name} />
                  </AccountImageContainer>
                  <Text styledTextProps={{ fontSize: '19px', fontWeight: '700' }}>
                    {account.name}
                  </Text>
                </AccountItem>
                <Button
                  name={getButtonName(account.id)}
                  onClick={() => switchAccount(account.id)}
                  bgColor={account.id === organizationId ? '#444444' : '#FFFFFF'}
                  txtColor={account.id === organizationId ? '#FFFFFF' : '#444444'}
                  styledTextProps={{ fontSize: '16px', fontWeight: '700' }}
                  customBorderRadius='4px'
                  borderColor='#444444'
                  styledWrapperProps={{ style: { padding: '6px 16px', borderWidth: '2px' } }}
                  disabled={isAccountLoading}
                />
              </AccountItemContainer>
            ))}
          </AccountContainer>
        ) : (
          <NoResultsContainer>
            <Title icon='opt-out'>No Accounts To Switch</Title>
          </NoResultsContainer>
        )}
      </ModalWrapper>
    </Modal>
  );
};

ModalAccountSwitch.propTypes = {
  organizationId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default ModalAccountSwitch;
